import React, {useState} from "react";
import {withNamespaces} from "react-i18next";
import {Button, Spinner} from "react-bootstrap";
import {languageHelper} from "../../../../helpers/language.helper";
import {connect} from "react-redux";
import {dashboardActions} from "../../../../actions/dashboard.actions";
import {dashboardService} from "../../../../services/dashboard.service";
import {modalActions} from "../../../../actions/modal.actions";
import WidgetVisitAddVisitForm from "../_forms/WidgetVisitAddVisitForm";
import {toastr} from "react-redux-toastr";

const WidgetVisit = ({t, visits, getDashboard, hideModal, showModal}) => {

    const [loading, setLoading] = useState(false);

    const stopLoading = (timeout = 500) => {
        setTimeout(() => {
            setLoading(false);
        }, timeout);
    }

    const createVisit = (model) => {
        setLoading(true);
        hideModal();
        dashboardService.createVisit(model).then(
            () => {
                stopLoading();
                getDashboard();
            },
            (error) => {
                stopLoading();
                hideModal();
                console.log(error)
            }
        )
    }

    const prev = (tag) => {
        setLoading(true);
        dashboardService.logVisitPrevStep(tag).then(
            () => {
                stopLoading(5000);
                getDashboard();
            },
            (error) => {
                stopLoading(5000);
                errorHandler(error);
            }
        )
    };

    const next = (tag) => {
        setLoading(true);
        dashboardService.logVisitNextStep(tag).then(
            () => {
                stopLoading(5000);
                getDashboard();
            },
            (error) => {
                stopLoading(5000);
                errorHandler(error, tag);
            }
        )
    }

    const close = (tag) => {
        setLoading(true);
        dashboardService.closeVisit(tag).then(
            () => {
                stopLoading();
                getDashboard();
            },
            (error) => {
                stopLoading();
                console.log(error)
            }
        )
    }

    const errorHandler = (error, tag = null) => {
        const { errorMessages } = error.response.data;
        const keys = Object.keys(errorMessages);

        if(keys.includes('DeviceGroup')) {
            errorMessages['DeviceGroup'].forEach((item) => {
                toastr.info(t('device-group'), t(`msg.${item}`));
            })
        }
        if(keys.includes('Tag')) {
            errorMessages['Tag'].forEach((item) => {
                if(item === 'reach_last_step') {
                    openModalConfirmCloseVisit(tag);
                }
            })
        }
    }

    const openModalCreate = () => {
        showModal({
            open: true,
            title: t('add-visit'),
            component: <WidgetVisitAddVisitForm submit={(model) => createVisit(model)}/>,
        }, 'formModal');
    }

    const openModalConfirmCloseVisit = (tag) => {
        console.log(tag);
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: `<p>${t('msg.reach_last_step')}</p>`,
            confirmLabel: t('OK'),
            confirmIcon: 'fa-check-circle',
            classNameBtnConfirm: 'btn-info',
            confirmAction: () => {
                close(tag);
                hideModal();
            },
        }, 'confirm')
    }

    return (
        <div className="mt-2">
            <div className="card">

                { !loading || (
                    <div className="overlay">
                        <Spinner animation={"border"} />
                    </div>
                ) }

                <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <b><span className="card-title"> { t('open-visits') } </span></b>
                        <Button size={"sm"} variant={"success"} onClick={() => openModalCreate()}>
                            { t('add-visit') } &nbsp; <i className="fas fa-plus-circle"/>
                        </Button>
                    </div>
                </div>
                <div className="card-body visits">
                    <div className="grid-container grid-template-header-visits gap-10">
                        <b className="border-right"><small>{t('card')}</small></b>
                        <b className="border-right text-center"/>
                        <b className="grid-item-center"><small>{t('prev')}</small></b>
                        <b className="grid-item-center text-center"><small>{t('current-step')}</small></b>
                        <b className="grid-item-center"><small>{t('next')}</small></b>
                        <b className="grid-item-right"><small>{t('close-visit')}</small></b>
                    </div>
                    <hr/>

                    {
                        visits?.length !== 0 || (
                            <h5 className='text-center p-2' >{t('visits- no-content')}</h5>
                        )
                    }

                    { visits?.map((item, idx) => {
                        return (
                            <React.Fragment key={idx}>
                                <div className="grid-container grid-template-body-visits gap-10">
                                    <div className="border-right grid-self-center">
                                        <h6 className="m-0">{ item.rfidTag?.label }</h6>
                                        <p className="m-0"><small>{ item.rfidTag?.tag }</small></p>
                                    </div>

                                    <div className="border-right grid-self-center">
                                        { item.language ? (
                                            <p className="m-0">
                                                <span className={`flag-icon flag-icon-${languageHelper.covertToISO_3166_1_alpha_2_code(item.language)}`}/>
                                                <small className="ml-1 text-uppercase">{languageHelper.covertToISO_3166_1_alpha_2_code(item.language)}</small>
                                            </p>
                                        ) : (
                                            <p className="m-0">
                                                {t('undefined')}
                                            </p>
                                        ) }
                                        <p className="m-0"><small>{ item.exhibitionScenario.label }</small></p>
                                    </div>

                                    <div className="grid-item-center grid-self-center">
                                        <Button variant="outline-secondary" disabled={item.deviceGroupId === null} onClick={() => prev(item.tag)}>
                                            <i className="fas fa-arrow-alt-circle-left" />
                                        </Button>
                                    </div>

                                    <div className="grid-item-center grid-self-center">
                                        { item.deviceGroup?.label || t("register") }
                                    </div>

                                    <div className="grid-item-center grid-self-center">
                                        <Button variant="outline-secondary" onClick={() => next(item.tag)}>
                                            <i className="fas fa-arrow-alt-circle-right" />
                                        </Button>
                                    </div>

                                    <div className="grid-item-right grid-self-center">
                                        <Button variant="outline-danger" onClick={() => openModalConfirmCloseVisit(item.tag)}>
                                            <i className="fas fa-times-circle" />
                                        </Button>
                                    </div>
                                </div>
                                <hr/>
                            </React.Fragment>
                        )
                    }) }
                </div>
            </div>
        </div>
    )
};
const mapDispatchToProps = (dispatch) => ({
    getDashboard: () => dispatch(dashboardActions.getDashboard()),
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    },
})
export default withNamespaces()(connect(null, mapDispatchToProps)(WidgetVisit));
